import { apiSlice } from "./apiSlice";

export const subjectAssessmentApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		// Get filtered assessments
		getFilteredAssessments: builder.query({
			query: ({ teacherId, subjectId, departmentId, schoolYearStart }) => ({
				url: "/SubjectAssessment/filtered",
				params: {
					teacherId,
					subjectId,
					departmentId,
					schoolYearStart,
				},
			}),
			providesTags: (result) =>
				result
					? [
							...result.map(({ id }) => ({ type: "SubjectAssessment", id })),
							{ type: "SubjectAssessment", id: "LIST" },
					  ]
					: [{ type: "SubjectAssessment", id: "LIST" }],
		}),

		// Get all assessments
		getAllSubjectAssessments: builder.query({
			query: () => "/SubjectAssessment",
			providesTags: (result) =>
				result
					? [
							...result.map(({ id }) => ({ type: "SubjectAssessment", id })),
							{ type: "SubjectAssessment", id: "LIST" },
					  ]
					: [{ type: "SubjectAssessment", id: "LIST" }],
		}),

		// Get assessment by ID
		getSubjectAssessmentById: builder.query({
			query: (id) => `/SubjectAssessment/${id}`,
			providesTags: (result, error, id) => [{ type: "SubjectAssessment", id }],
		}),

		// Create assessment
		createSubjectAssessment: builder.mutation({
			query: (assessmentData) => ({
				url: "/SubjectAssessment",
				method: "POST",
				body: assessmentData,
			}),
			invalidatesTags: [{ type: "SubjectAssessment", id: "LIST" }],
		}),

		// Update assessment
		updateSubjectAssessment: builder.mutation({
			query: ({ id, ...assessmentData }) => ({
				url: `/SubjectAssessment/${id}`,
				method: "PUT",
				body: assessmentData,
			}),
			invalidatesTags: (result, error, { id }) => [
				{ type: "SubjectAssessment", id },
				{ type: "SubjectAssessment", id: "LIST" },
			],
		}),

		// Delete assessment
		deleteSubjectAssessment: builder.mutation({
			query: (id) => ({
				url: `/SubjectAssessment/${id}`,
				method: "DELETE",
			}),
			invalidatesTags: [{ type: "SubjectAssessment", id: "LIST" }],
		}),
	}),
});

export const {
	useGetFilteredAssessmentsQuery,
	useGetAllSubjectAssessmentsQuery,
	useGetSubjectAssessmentByIdQuery,
	useCreateSubjectAssessmentMutation,
	useUpdateSubjectAssessmentMutation,
	useDeleteSubjectAssessmentMutation,
} = subjectAssessmentApiSlice;
